
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement("path", { d: "m62 28.3h-60c0 0 1.8 16.6 4.9 21.2 3.5 5.1 11.8 12.5 25.1 12.5 13.3 0 21.6-7.4 25.1-12.5 3.1-4.6 4.9-21.2 4.9-21.2", fill: "#e0dac6" }),
	React.createElement("path", { d: "m62 28.3c0 5.7-13.4 10.3-30 10.3-16.6.1-30-4.6-30-10.3 0-5.7 13.4-10.3 30-10.3 16.6 0 30 4.6 30 10.3", fill: "#f9f3d9" }),
	React.createElement("path", { d: "m61 28.1c0 5.2-13 9.4-29 9.4-16 0-29-4.2-29-9.4 0-5.2 13-9.4 29-9.4 16 .1 29 4.3 29 9.4", fill: "#e0dac6" }),
	React.createElement("path", { d: "m32 22c-14.3 0-26.2 3.3-28.6 7.7 2.4 4.4 14.3 7.8 28.6 7.8 14.3 0 26.2-3.3 28.6-7.8-2.4-4.3-14.3-7.7-28.6-7.7", fill: "#f2b200" }),
	React.createElement("path", { d: "m32 46.8c13.2 0 24.3-3.2 28.4-7.7.5-2.4.8-4.8 1.1-6.7-2.6 4.8-14.8 8.4-29.5 8.4-14.7 0-26.9-3.6-29.5-8.4.3 1.9.6 4.3 1.1 6.7 4.1 4.5 15.2 7.7 28.4 7.7", fill: "#b3682a" }),
	React.createElement(
		"g",
		{ fill: "#ffe299" },
		React.createElement("path", { d: "m47.6 34.1l-.2-2.5.8-.1c4-.3 5.6-1.8 5.6-2.9.1-1.3-1.4-2.5-3.6-2.9-.6-.1-1.2-.2-1.8-.2-2 0-3.6.6-5.6 1.3-2.6 1-5.5 2-9.8 2-2.5 0-5.3-.8-8.2-1.7-2.9-.9-6-1.8-8.7-1.8-1.9 0-3.5.4-4.9 1.3-.8.5-2 1.4-1.7 2.2.6 1.3 4.2 2.6 7.3 2.6.4 0 .7 0 1.1-.1l.7-.1.4 2.5-.9.3c-.4 0-.8.1-1.3.1-3.3 0-8.5-1.3-9.7-4.1-.4-1-.7-3.1 2.7-5.2 1.8-1.1 3.9-1.7 6.3-1.7 3.2 0 6.6 1 9.5 1.9 2.7.8 5.3 1.6 7.4 1.6 3.8 0 6.5-1 8.9-1.9 2-.7 4.1-1.5 6.5-1.5.8 0 1.5.1 2.3.2 3.5.7 5.8 2.9 5.7 5.5-.1 2.2-2.3 4.8-8 5.2h-.8" }),
		React.createElement("path", { d: "m39.7 33.8c-2.3 0-4.6-.5-6.9-1.6-5.1-2.3-9.2-2.8-11.8-2.8-3.2 0-5 .7-5.7 1l-.6.3-1.2-2.2.7-.3c.9-.4 3.4-1.4 7.6-1.2 3.9.1 8 1.1 12.1 3 2 .9 3.9 1.4 5.8 1.4 3.3 0 6.2-1.5 8-4.1l.4-.6 2.2 1.3-.5.7c-1.8 2.6-4.4 4.3-7.5 4.9-.8.1-1.7.2-2.6.2" }),
		React.createElement("path", { d: "m33.1 35.4l-.6-.3c-1.7-.8-3.4-1.2-5.3-1.2-3.1 0-5.3 1.2-5.3 1.2l-.6.3-1.4-2.1.7-.4c.3-.2 2.9-1.5 6.5-1.5 2.2 0 4.4.5 6.4 1.5l.7.3-1.1 2.2" }),
		React.createElement("path", { d: "m22.4 12.6l-1.2-2.3.7-.4c2.3-1.2 3.4-5.6 3.4-5.7l.2-.7 2.5.7-.2.7c-.1.2-1.4 5.5-4.7 7.3l-.7.4" }),
		React.createElement("path", { d: "m33.2 14.2l-2.1-1.4.4-.6c0 0 1.6-2.5 2-4.8l.1-.7 2.6.4-.2.6c-.5 3-2.3 5.8-2.4 5.9l-.4.6" }),
		React.createElement("path", { d: "m29.2 13.2l-2.1-1.4.4-.6c0 0 1.6-2.5 2-4.8l.1-.7 2.6.3-.1.7c-.5 3-2.3 5.8-2.4 5.9l-.5.6" })
	),
	React.createElement(
		"g",
		{ fill: "#d3976e" },
		React.createElement("path", { d: "m62 12l-40.6-7.7-.2 1.1 40.4 9.7z" }),
		React.createElement("path", { d: "m59.7 21.1l-38.6-14.6-.4 1 38 16.5z" })
	),
	React.createElement(
		"g",
		{ fill: "#ffe299" },
		React.createElement("path", { d: "m25.2 12.4c-.8 0-1.5-.4-2.1-1.1-1.5-1.8-.8-5.3.1-7.1.8-1.8 1.8-2.2 2.5-2.2.7 0 1.3.3 1.7.8.6.8.5 1.8.4 2.1l-2.2-.1c0 .1-.2.5-.2.5-.7 1.7-.8 3.8-.4 4.4.1.1.1.1.2.1 0 0 .1.1.2-.2l2.4.9c-.5 1.1-1.3 1.7-2.3 1.9-.1 0-.2 0-.3 0" }),
		React.createElement("path", { d: "m29.5 13.9c-.8 0-1.6-.4-2.1-1.1-2.1-2.8-.9-6.5.3-8.2.9-1.2 1.7-1.5 2.2-1.5.2 0 .4 0 .5.1.7.3 1.8.8 1.6 3.1l-2.3-.4c-.6 1.2-1.1 4.2-.2 5.5l2.3 1c-.4.9-1.1 1.5-2 1.6-.2-.1-.2-.1-.3-.1" }),
		React.createElement("path", { d: "m33.5 25.1c.8-2.1-1.2-5.6-1.9-7.3-1.3-3.2-1.1-11.7 1.3-13.3.7-.5 1.5-.6 2.2-.2.7.3 1.4 1.5 1.2 2.9l-2.3-.5c-.6 1.8-1 8.1.2 10.8.9 1.9 2.6 4.9 1.6 8.1-.7 2-2.9 1-2.3-.5" })
	)
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/ramen.js
// module id = 716
// module chunks = 0